import React, { useEffect, useRef, useState } from 'react';
import ApolloHero from './ApolloHero.js';


import HorizontalContainer from './HorizontalContainer';
import moon1 from '../assets/images/moon1.png';
import moon2 from '../assets/images/moon2.png';
import moon3 from '../assets/images/moon3.png';
import david from '../assets/images/david.png';
import stars from '../assets/images/stars.jpg';
import brown from '../assets/images/brown.png'
import fadeToBlack from '../assets/images/Rectangle.png';

const blocks1 = [
    {
        quote: "Over time, geologic features are often destroyed by things like large impacts, micro meteorites and the solar wind.",
        name: "David Williams",
        role: "Planetary Geologist and Volcanologist",
        avatar: david,
    },
];

const blocks2 = [
    {
        quote: "When we look at the far side of the moon, we’re often amazed that it’s very, very different from the near side.",
        name: "David Williams",
        role: "Planetary Geologist and Volcanologist",
        avatar: david,
    },
    {
        quote: "The dark patches differ drastically in age and structure.",
        name: "Apollo Mission Archive",
        role: "NASA Analysis",
    },
];

const blocks3 = [
    {
        quote: "Some of the surface shows ancient volcanic patterns called 'maria'.",
        name: "Lunar Team",
        role: "Geology Unit",
        avatar: david,
    },
    {
        quote: "We think the Aratus region is an ancient volcano.",
        name: "David Williams",
        role: "Planetary Geologist",
        avatar: david,
    },
];


const ApolloPage = () => {
    const nextRef = useRef(null);
    const [bgSize, setBgSize] = useState("cover");

    const scrollToNext = () => {
        nextRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        const updateSize = () => {
            setBgSize(window.innerWidth >= 800 ? "contain" : "cover"); // 768px is Tailwind's md breakpoint
        };

        updateSize(); // Initial check
        window.addEventListener("resize", updateSize);

        return () => window.removeEventListener("resize", updateSize);
    }, []);

    return (
        <div>
            <ApolloHero onScrollNext={scrollToNext} />


            <div ref={nextRef}
                className="relative w-full"
                style={{
                    backgroundImage: `url(${brown})`,
                    backgroundSize: bgSize,
                    backgroundPosition: "start",
                }}>

                <HorizontalContainer image={moon1} textBlocks={blocks1} />
                <HorizontalContainer image={moon2} textBlocks={blocks2} />

                <HorizontalContainer image={moon3} textBlocks={blocks3} />
                <HorizontalContainer image={moon3} textBlocks={blocks3} />

                {/* Gradient fade overlay into stars */}
                <img
                    src={fadeToBlack}
                    alt="fade to black"
                    className="absolute -bottom-26   left-0 w-full h-32 z-10 pointer-events-none"
                    style={{
                        objectFit: 'cover',
                    }}
                />

            </div>

            <footer className="relative h-[30vh] w-full bg-black text-white overflow-hidden">
                {/* Starry background */}

                <img
                    src={stars}
                    alt="stars"
                    className="absolute inset-0 w-full h-[100%] object-cover z-0"
                />

                {/* Footer text block */}
                <div className="relative z-10 h-full flex flex-col  justify-end pb-20 px-10">
                    <div className="w-full max-w-full border-t border-white/30 mb-4" />
                    <h2 className="text-2xl md:text-3xl font-medium tracking-wide text-left">
                        Because Science
                    </h2>
                </div>
            </footer>

        </div>
    );
};

export default ApolloPage;
